import * as THREE from 'three';

import GameplayState from './state/gameplay';
import Runner from './runner';

import 'css/game.css';

class Game {
  constructor (width, height, container) {
    const renderer = new THREE.WebGLRenderer();

    if (this.isMobile()) {
      renderer.setSize(window.innerWidth, window.innerHeight);
    } else {
      renderer.setSize(width, height);
    }

    container.style.width = renderer.getSize().width + 'px';
    container.style.height = renderer.getSize().height + 'px';

    renderer.shadowMap.enabled = true;

    const gameState = new GameplayState(renderer);
    const runner = new Runner(gameState, renderer);

    this.runner = runner
    this.renderer = renderer;
    this.gameState = gameState;

    container.appendChild(renderer.domElement);
  }

  isMobile () {
    const isMobile = window.matchMedia("only screen and (max-width: 760px)");
    return isMobile.matches || (navigator && navigator.plugins.length === 0);
  }

  play () {
    this.runner.run();
  }
}

window.Game = Game;



// WEBPACK FOOTER //
// ./src/main.js